<template>
  <div class="category-showcase">
    <MyLink
      v-for="category in categories"
      name="category"
      :params="{ categorySlug: category.slug }"
      class="category-showcase__item"
      :class="{ hidden: !isShownCategory }"
    >
      <img
        :src="category.getImageUrl('catalogImage')"
        :alt="category.getName()"
        class="category-showcase__item-image"
      />
      <p class="category-showcase__item-title">
        {{ category.getName() }}
      </p>
    </MyLink>
  </div>
  <div
    v-if="categories.length > 2"
    class="category-showcase__button"
    @click="onShowCategory"
  >
    <img
      v-show="!isShownCategory"
      class="category-showcase__button-icon"
      src="~/assets/icons/eye-show.svg"
      alt="show button"
    />
    <img
      v-show="isShownCategory"
      class="category-showcase__button-icon"
      src="~/assets/icons/eye-hide.svg"
      alt="show button"
    />
    <span class="category-showcase__button-text">
      {{ isShownCategory ? _T("@Hide") : _T("@All categories") }}
    </span>
  </div>
</template>

<script setup>
const props = defineProps({
  categories: { type: Array, required: true },
});

const isShownCategory = ref(false);

const onShowCategory = () => {
  isShownCategory.value = !isShownCategory.value;
};
</script>

<style scoped lang="scss">
.category-showcase {
  @extend %width-main;

  @include flex-container(row, flex-start);
  flex-wrap: wrap;

  gap: 8px;

  margin-bottom: 32px;

  @include bigMobile {
    flex-direction: column;
    flex-wrap: nowrap;

    margin-bottom: 16px;

    overflow: hidden;
  }

  &__item {
    width: min(100%, 172px);

    @include flex-container(column, flex-start, center);
    gap: 16px;

    background-color: white;
    border-radius: 8px;

    padding: 8px;

    transition: box-shadow 0.2s;

    @include bigMobile {
      width: 100%;

      flex-direction: row;
      gap: 8px;

      padding: 8px 16px;

      &.hidden:nth-child(n + 3) {
        display: none;
      }
    }

    &:hover {
      @extend %shadow;

      & .category-showcase__item-title {
        text-decoration-line: underline;
      }
    }
  }

  &__item-image {
    max-width: 100%;
    max-height: 100%;

    aspect-ratio: 4/3;

    @include bigMobile {
      @include fixedHW(40px);
      object-fit: cover;
    }
  }

  &__item-title {
    @include font(14, 20);
    text-align: center;
    color: #0356a4;

    @include bigMobile {
      text-align: left;
    }
  }

  &__button {
    display: none;
    width: 100%;

    background-color: white;
    border: 1px solid var(--color-sky-base);
    border-radius: 30px;

    margin-bottom: 16px;
    padding: 8px;

    @include bigMobile {
      @include flex-container(row, center, center);
      gap: 4px;
    }
  }

  &__button-icon {
    @include fixedHW(14px);
  }

  &__button-text {
    @include font(14, 18);
  }
}
</style>
